import { ModuleType } from '../../../../constants';
import { IconType } from '../../../Icons';

export type SetupModulePageQueryParams = {
  moduleId: string;
  moduleType: ModuleType;
  preset: string;
};

export enum ModuleTypes {
  Core = 'module',
  Global = 'global',
  Local = 'local',
  Authenticated = 'authenticated', // extension module that is authenticated (is saved as global)
}

export interface ModuleFormValuesType {
  id: string;
  label: string;
  icon: IconType;
  type: ModuleTypes; // when setting up module the type can also be `authenticated`
  embedCode?: string;
  autoSizeEmbed?: boolean;
  embedlyData?: any;
  disabled?: boolean; // used for disabled modules
  embedLink?: string;
  content?: string;
  viewType?: string;
}
